import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL6020_R01 } from "./Content_SAL6020_R01";
import { SearchSection_SAL6020_R01 } from "./SearchSection_SAL6020_R01";
import { useSAL6020_R01Store } from "./Store_SAL6020_R01";
import { Table_SAL6020_R01 } from "./Table_SAL6020_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL6020_R01DetailDto, SAL6020_R01Dto, SAL6020_R01HeaderDto } from "./Dto_SAL6020_R01";
import { DetailTable_SAL6020_R01 } from "./DetailTable_SAL6020_R01";


export const Container_SAL6020_R01 = () => {

	const { 
		allCount,
		initData, 
	} = useSAL6020_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'SAL6020_R01',
		type: 'height',
		storageKey: 'SAL6020_R01-split-width',
		min: 5,
		max: 80,
		default: 37
	} as const;
	const gridRef = useRef<AgGridReact<SAL6020_R01HeaderDto>>(null); 
	const detailGridRef = useRef<AgGridReact<SAL6020_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
	} = Content_SAL6020_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={()=>{}}
			onDeleteClick={ ()=>{}}
			onSaveClick={()=>{}}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={() => { initData(); } }
		/>
		<SearchSection_SAL6020_R01 />

		<div className="flex flex-col flex-1 px-[12px] gap-[4px] p-[10px]" ref={containerRef} >
			<div className="w-full" style={{ height: `${splitValue}%` }}>
				<Table_SAL6020_R01 gridRef={gridRef} />
			</div>
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('UD', e.nativeEvent)}
				data-comment="리사이즈"
			/>
			<div className="w-full" style={{ height: `${100 - splitValue}%` }} ref={infoRef}>
				<DetailTable_SAL6020_R01 gridRef={detailGridRef} />
			</div>
		</div>
		<Message />
	</div>
}
